

import React from "react";
import { i18nManager } from "../i18n";
import { ITransaction } from "../services";
import successIcon from "../assets/images/success.gif";
import warningIcon from "../assets/images/success.gif";
import errorIcon from "../assets/images/error_info.gif";
import { Button, Classname, Scheme } from "@rivtn/noseur";
import { Utils } from "../utils";
import Loading from "./Loading";

export interface ErrorSuccessViewProps {
    messages: string[];
    redirectUrl?: string;
    transaction?: ITransaction;
    type?: "SUCCESS" | "ERROR" | "WARNING";
    actions?: {
        text: string;
        scheme: Scheme;
        raised?: boolean;
        outlined?: boolean;
        fillOnHover?: boolean;
        onClick: () => void;
    }[];
}

function ErrorSuccessView(props: ErrorSuccessViewProps) {

    const transaction = props.transaction;
    const redirectUrl = props.redirectUrl;
    const labels = i18nManager.Labels.error;
    const [performingAction, setPerformingAction] = React.useState<boolean>(false);
    const [secondsToRedirection, setSecondsToRedirection] = React.useState<number>(transaction?.configuration?.auto_redirect_wait_timeout ?? 5);

    React.useEffect(() => {
        if (!redirectUrl) return;
        if (!(Utils.equalsAny(transaction?.configuration?.redirect_logic, ["USER_ACTION_AUTO_REDIRECT", "AUTO_REDIRECT"]))) return;
        if (transaction?.configuration?.redirect_logic === "AUTO_REDIRECT" || secondsToRedirection === 0) {
            triggerRedirect();
            return;
        }
        setTimeout(() => setSecondsToRedirection(secondsToRedirection - 1), 1000);
    }, [secondsToRedirection]);

    if (transaction?.configuration?.redirect_logic === "AUTO_REDIRECT") {
        return <Loading />;
    }

    return (<div className={Classname.build("error", { "success": (props.type === "SUCCESS"), "warning": (props.type === "WARNING") })}>
        {(props.type === "SUCCESS") && <img src={successIcon} alt={props.type} />}
        {(props.type === "WARNING") && <img src={warningIcon} alt={props.type} />}
        {(!props.type || props.type === "ERROR") && <img src={errorIcon} alt={props.type} />}
        {(!props.type || props.type === "ERROR") && <span style={{ color: "#F3564D" }}>{labels.error}</span>}
        {props.messages.map((message) => (<span key={message}>{message}</span>))}
        {((!transaction || transaction?.configuration?.redirect_logic != "NO_ACTION")) && (<div className="actions">
            {props.actions?.map((action) => (<Button key={action.text} {...action} {...(performingAction ? Utils.BUTTON_LOADING_PROPS : {})} fill />))}
        </div>)}
        {(redirectUrl && transaction?.configuration?.redirect_logic === "USER_ACTION_AUTO_REDIRECT") && (<div className="redirect">
            <span className="info">You will be redirected back to the business in <span>{secondsToRedirection}</span></span>
        </div>)}
    </div>);

    function triggerRedirect() {
        setPerformingAction(true);
        if (!redirectUrl) {
            window.history.back();
            return;
        }
        window.location.replace(redirectUrl);
    }

}

export default ErrorSuccessView;
